module.exports = __webpack_public_path__ + "static/media/video-1.da41edbb.jpg";